<wms-dialog-header title="{{locale.LABEL_ARTIFACT_UPDATES}}" [showClose]="false"></wms-dialog-header>
<wms-dialog-body>
    <div class="wm-form">
      <div class="errorMessageContainer">
        <wms-message [scopeDataset]="statusMessages" hideclose="true"></wms-message>
      </div>
        <table class="wm-table">
            <colgroup>
                <col width="130">
                <col width="130">
                <col width="130">
                <col width="300">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>{{locale.LABEL_SERVICE_NAME}}</th>
                    <th>{{locale.LABEL_VERSION_CURRENT}}</th>
                    <th>Latest Version</th>
                    <th>{{locale.LABEL_DESCRIPTION}}</th>
                    <th>{{locale.LABEL_ACTIONS}}</th>
                </tr>
            </thead>
        </table>
        <div class="change-table-container">
          <table class="wm-table">
              <colgroup>
                  <col width="130">
                  <col width="130">
                  <col width="130">
                  <col width="300">
                  <col>
              </colgroup>
              <tbody>
                  <!-- Prefab Conflicts -->
                  <tr *ngFor="let conflict of prefabConflicts">
                      <td>
                        {{locale.LABEL_PREFAB}} - {{conflict.name}}
                        <p *ngIf="conflict.upgradableVersions && conflict.publisherName"><span class="text-muted">{{locale.LABEL_BY}}  </span> {{conflict.publisherName}}</p>
                      </td>
                    <td class="text-center">{{conflict.readableVersion}}<span class="block-text">{{conflict.readableVersion ?'('+conflict.version+')' : conflict.version}}</span></td>
                      <td class="text-center">{{conflict.greaterReadableVersion}}<span class="block-text">{{conflict.greaterReadableVersion ?'('+conflict.greaterVersion+')' : conflict.greaterVersion}}</span></td>
                      <td *ngIf="conflict.artifactId.startsWith('workspace')||(studioService.selectedOrganization.mode === 'OWN' && preferences.workspace.wmEnv !== 'WME')">
                        {{ locale.MESSAGE_PREFAB_VERSION_MISMATCH_OLDER.replace('${0}', conflict.name).replace('${1}', conflict.greaterVersion).replace('${2}', locale.LABEL_UPDATE) }}
                                              </td>
                    <td *ngIf="studioService.selectedOrganization.mode !== 'OWN' ||  preferences.workspace.wmEnv === 'WME'">
                      {{ locale.MESSAGE_ORG_PREFAB_VERSION_MISMATCH_OLDER.replace('${0}', conflict.name).replace('${1}',conflict.version).replace('${2}',conflict.greaterVersion).replace('${3}', locale.LABEL_UPDATE )}}
                    </td>
                      <td class="prefab-actions">
                        <ng-container  *ngIf="conflict.upgradableVersions.length>0">
                        <select name="1" [(ngModel)]="conflict.greaterVersionId" *ngIf="(studioService.selectedOrganization.mode !== 'OWN' ||  preferences.workspace.wmEnv === 'WME') && !conflict.resolved">
                          <ng-container *ngFor="let version of conflict.upgradableVersions">
                            <option value="{{version.versionId}}">
                              {{version.branch && ('v' + version?.version + ' (' + version?.branch + ')') || (version?.readableVersion ? version?.readableVersion+' ('+version?.version+')' :locale.LABEL_ARTIFACT_VERSION + ' ' + version?.version)}}
                            </option>
                          </ng-container>
                        </select>
                        </ng-container>
                        <select  name="2" [(ngModel)]="conflict.greaterVersionId" *ngIf="(studioService.selectedOrganization.mode !== 'OWN' || preferences.workspace.wmEnv === 'WME') &&  (conflict.artifactStatus === 'DEV' && conflict.upgradableVersions.length>0 && conflict.upgradableVersions[0]?.version!=conflict.version)">
                          <option *ngFor="let version of conflict.upgradableVersions" value="{{version?.versionId}}">{{locale.LABEL_ARTIFACT_VERSION}} {{version?.version}}&#125;</option>
                        </select>
                        <button class="btn btn-primary app-button" *ngIf="!conflict.resolved" [disabled]="conflict.disabled || disableDialogActions " (click)="registerPrefab(conflict, conflict.greaterVersionId)">{{locale.LABEL_UPDATE}}</button>
                        <i *ngIf="conflict.resolved" class="wms wms-done-bold"></i>
                      </td>
                  </tr>

                  <!-- Theme Conflicts -->
                  <tr *ngFor="let conflict of themeConflicts ">
                      <td>{{locale.LABEL_THEME}}</td>
                          <td class="text-center">{{conflict.version}}</td>
                          <td class="text-center">{{conflict.latestVersion}}</td>
                          <td>{{conflict.versionMessage}}</td>
                          <td class="text-center">
                            <button class="app-button btn btn-primary" *ngIf="!conflict.resolved" [disabled]="disableDialogActions" (click)="registerTheme(conflict)">{{locale['LABEL_' + conflict.actionsBtnMsg.toUpperCase()]}}</button>
                            <i *ngIf="conflict.resolved" class="wms wms-done-bold"></i>
                          </td>
                      </tr>
              </tbody>
          </table>
      </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <button class="app-button btn btn-primary" name="project-changes-cancel"
            [disabled]="disableDialogActions"
            (click)="closeDialogWithId()"
            [title]="locale['LABEL_CONTINUE']">{{locale.LABEL_CONTINUE}}</button>
</wms-dialog-footer>
